export enum CurvatureToStress {
  TOTAL_CURVATURE = 'TOTAL_CURVATURE',
  MEAN_BASED = 'MEAN_BASED',
}
